import { Download, Mail, Share2 } from "lucide-react";

const origin = window.location.origin;
const CARD = `${origin}/api/share/card.png`;
const FB = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${origin}/api/share?v=5`)}`;

const FbIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
    <path d="M13.5 21v-7.5h2.5l.4-3h-2.9V8.6c0-.9.3-1.5 1.5-1.5h1.5V4.4c-.3 0-1.2-.1-2.2-.1-2.2 0-3.7 1.3-3.7 3.8v2.4H8v3h2.6V21h2.9z" />
  </svg>
);

const nativeShare = async () => {
  try {
    const blob = await (await fetch(CARD)).blob();
    const file = new File([blob], "i-voted-tss-sharod-shamman-2026.png", { type: "image/png" });
    if (navigator.canShare?.({ files: [file] })) {
      await navigator.share({ files: [file], text: `I voted in TSS Sharod Shamman 2026 Public Voting! Vote now: ${origin}/ শুভ শারদীয়া` });
      return;
    }
  } catch {
    return;
  }
  window.open(FB, "_blank", "noopener");
};

export const ShareCard = ({ confirmation }) => (
  <div data-testid="share-card" className="mt-6 rounded-2xl border border-gold/50 bg-ivory p-4">
    <p className="text-center font-display text-lg font-bold text-maroon">Tell your friends you voted!</p>
    <img src={CARD} alt="I voted in TSS Sharod Shamman 2026 Public Voting" data-testid="share-card-image" className="mt-3 w-full rounded-xl border border-gold/40 shadow-festive" />
    <a href={FB} target="_blank" rel="noopener noreferrer" data-testid="share-facebook-btn" className="mt-4 flex h-12 w-full items-center justify-center gap-2 rounded-full bg-[#1877F2] font-semibold text-white transition-transform active:scale-95">
      <FbIcon /> Share on Facebook
    </a>
    <div className="mt-2 grid grid-cols-2 gap-2">
      <button type="button" onClick={nativeShare} data-testid="share-native-btn" className="flex h-11 items-center justify-center gap-2 rounded-full border border-maroon text-sm font-semibold text-maroon">
        <Share2 className="h-4 w-4" /> Share image
      </button>
      <a href={CARD} download="i-voted-tss-sharod-shamman-2026.png" data-testid="share-download-btn" className="flex h-11 items-center justify-center gap-2 rounded-full border border-maroon text-sm font-semibold text-maroon">
        <Download className="h-4 w-4" /> Download
      </a>
    </div>
    {confirmation?.email && (
      <p data-testid="confirmation-email-note" className="mt-3 flex items-center justify-center gap-1.5 text-xs text-forest">
        <Mail className="h-3.5 w-3.5" /> A confirmation email is on its way.
      </p>
    )}
  </div>
);
